var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconLinkedinColoured = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22 3.5v17.1a1.54 1.54 0 01-1.5 1.5h-17C2.7 22 2 21.3 2 20.5v-17A1.54 1.54 0 013.5 2h17.1c.7 0 1.4.7 1.4 1.5zm-2.9 15.6v-5.8c0-2.9-1.8-4-3.5-4a3.07 3.07 0 00-2.9 1.5h-.1V9.6h-3V19h2.9v-5c-.1-1.1.7-2 1.8-2.1h.1c.9 0 1.6.6 1.6 2.1v5h3.1zM7.9 6.2V6a1.58 1.58 0 00-1.6-1.6h-.2c-.6 0-1.3.3-1.5.9-.7 1.3.2 2.6 1.5 2.6 1 0 1.8-.8 1.8-1.7zm0 12.9V9.6h-3V19h3z",
  fill: "#0073b1"
})));

export default SvgIconLinkedinColoured;